import './header'
import './forms'
import './aniBG'
import './fslightbox'

const windowWidth = window.innerWidth;
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.popup__close').forEach(button => {
      button.addEventListener('click', function() {
          this.closest('.popup').classList.remove('active')
      });
  });

  fixedheader();
  optimizationOfVideos();

  const headElement = document.querySelector('.iservices__head');
  const arrowElement = document.querySelector('.iservices__arrow');
  const firstWrapElement = document.querySelector('.iservices__list__item__wrap');

  if (windowWidth >992) { 
    // Ensure the first wrap element exists
    if (firstWrapElement) {
        // Get the height of the first wrap element
        const wrapHeight = firstWrapElement.offsetHeight;

        // Set the height of .iservices__head and .iservices__arrow
        if (headElement) {
            headElement.style.height = wrapHeight + 'px';
        }
        
        if (arrowElement) {
            arrowElement.style.height = wrapHeight + 'px';
        }
    }
  }

  const videos = document.querySelectorAll(".article__opinion__video video");

  videos.forEach(video => {
    video.addEventListener('click', function() {
      if (video.classList.contains('playing')) {
        video.pause();
        video.classList.remove('playing');

      } else {
        video.play();
        video.classList.add('playing');

      }
      
    });

  });

  const glightbox = document.querySelectorAll('.glightbox');
  if (glightbox != null) {
    var lightbox = GLightbox();

  }

  const homeblog__list = new Swiper('.iblog__list', {
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    speed: 650,
    // freeMode: true,
    spaceBetween: 12, 
    mousewheel: {
        releaseOnEdges: true,
    },
    breakpoints: {
      576: {
        spaceBetween: 20,
      },
      1200: {
        spaceBetween: 30,
      },
      1800: {
        spaceBetween: 40
      }
    },
    on: {
      // slideChange: function() {
      //     // Get the current index of the active slide
      //     const currentIndex = this.activeIndex;
      //     const element = document.querySelector('.iblog .sidetitle'); // The element you want to modify

      //     // Check if the current index is 0 (first slide)
      //     if (currentIndex === 0) {
      //         // Add a class when on the first slide
      //         element.classList.remove('hide'); 
      //     } else {
      //         // Remove the class if not on the first slide
      //         element.classList.add('hide');
      //     }
      // },
    },
  });


  const iClientsLogos = document.querySelectorAll('.iclients__list img');
  let loadedImagesCount = 0; // Счетчик загруженных изображений

  // Функция, которая будет выполняться когда все изображения загружены
  function checkAllImagesLoaded() {
      loadedImagesCount++;
      if (loadedImagesCount === iClientsLogos.length) {
          resizeiClientsLogos(); // Вызываем функцию изменения размеров после загрузки всех изображений
      }
  }

  function resizeiClientsLogos() {
    if (iClientsLogos.length == 0) return;

      // const windowWidth = window.innerWidth;

      iClientsLogos.forEach(logo => {
          const originalWidth = logo.naturalWidth; // Получение оригинальной ширины
          let newWidth;

          if (windowWidth < 576) { 
            newWidth = originalWidth * 0.41; 
          } else if (windowWidth < 1100) { 
              newWidth = originalWidth * 0.58; 
          } else if (windowWidth < 1580) { 
              newWidth = originalWidth * 0.85; 
          } else {
              newWidth = originalWidth; 
          }
          logo.style.width = newWidth + 'px'; // Применение нового размера

      });
  }

  iClientsLogos.forEach(logo => {
      if (logo.complete) {
          checkAllImagesLoaded(); // Если изображение уже загружено
      } else {
          logo.addEventListener('load', checkAllImagesLoaded); // Если не загружено, добавляем обработчик
          logo.addEventListener('error', checkAllImagesLoaded); // В случае ошибки также учитываем
      }
  });
  window.addEventListener('resize', resizeiClientsLogos);


// ----------------------------------------
  const cliLogos = document.querySelectorAll('.clients__list img');
  let loadedImagesCount2 = 0; // Счетчик загруженных изображений

  function checkAllImagesLoaded2() {
      loadedImagesCount2++;
      if (loadedImagesCount2 === cliLogos.length) {
        
        resizecliLogos(); // Вызываем функцию изменения размеров после загрузки всех изображений
      }
  }

  function resizecliLogos() {
    if (cliLogos.length == 0) return;
      // const windowWidth = window.innerWidth;
      cliLogos.forEach(logo => {
          const originalWidth = logo.naturalWidth; // Получение оригинальной ширины
          let newWidth;

          if (windowWidth < 690) { 
            newWidth = originalWidth * 0.4; 
          } else if (windowWidth < 1100) { 
              newWidth = originalWidth * 0.56; 
          } else if (windowWidth < 1580) { 
              newWidth = originalWidth * 0.6; 
          } else {
              newWidth = originalWidth * 0.83; ; 
          }
          logo.style.width = newWidth + 'px'; // Применение нового размера

      });
  }

  cliLogos.forEach(logo => {
      if (logo.complete) {
          checkAllImagesLoaded2(); // Если изображение уже загружено
      } else {
          logo.addEventListener('load', checkAllImagesLoaded2); // Если не загружено, добавляем обработчик
          logo.addEventListener('error', checkAllImagesLoaded2); // В случае ошибки также учитываем
      }
  });
  window.addEventListener('resize', resizecliLogos);



  gsap.registerPlugin(ScrollTrigger);


// Selecting the parent and child elements
const parent = document.querySelector('.iservices');
const children = gsap.utils.toArray('.iservices__list__item__wrap');
const iservices__head = document.querySelector('.iservices__head');
const iservices__arrow = document.querySelector('.iservices__arrow');
let spacePin = 120;
let spaceiservices__head = 0;


function setParentHeight() {
  const lastChild = children[children.length - 1];
  
  if (lastChild) {
    const lastChildBottom = lastChild.getBoundingClientRect().bottom; // Нижний край последнего дочернего элемента
    const parentTop = parent.getBoundingClientRect().top; // Верхний край родителя

    const newHeight = lastChildBottom - parentTop;
    
    parent.style.height = `${newHeight}px`;
  }
}

setParentHeight(); 
// Обновление высоты при скролле
// ScrollTrigger.addEventListener("scrollEnd", setParentHeight);

window.addEventListener('resize', setParentHeight);

if (windowWidth < 432) { 
  spacePin = 90; 
  spaceiservices__head = -200; 
} else if (windowWidth < 576) { 
  spacePin = 80; 

} else if (windowWidth < 690) { 
  spaceiservices__head = -225; 
  spacePin = 110; 

} else if (windowWidth < 992) { 
  spaceiservices__head = -200;
  spacePin = 90; 
} else if (windowWidth < 1350) { 
  spacePin = 100; 
} else if (windowWidth < 1580) { 
  spacePin = 130; 
} else {
  spacePin = 130; 
}
// console.log(spacePin);

  ScrollTrigger.create({
    trigger: iservices__head,
    start: `center 50%+=${spaceiservices__head}`,
    endTrigger: parent,
    end: `bottom 80%`,
    pin: true,
    pinSpacing: false,
    // markers: true,
    id: 'pin',
    invalidateOnRefresh: true,
  });
if (windowWidth >992) { 
  ScrollTrigger.create({
    trigger: iservices__arrow,
    start: `center 50%`,
    endTrigger: parent,
    end: `bottom 80%`,
    pin: true,
    pinSpacing: false,
    // markers: true,
    id: 'pin',
    invalidateOnRefresh: true,
  });
}

children.forEach((card, index) => {
  
  ScrollTrigger.create({
    trigger: card,
    start: `center 50%+=${spacePin*index}`,
    endTrigger: parent,
    end: `bottom 80%`,
    pin: true,
    pinSpacing: false,
    // markers: true,
    id: 'pin',
    invalidateOnRefresh: true,
    onUpdate: setParentHeight
  });

});

// ScrollTrigger.create({
//     trigger: parent,
//     start: 'top 20%',
//     end: 'bottom center',
//     // pin: true,
//     pinSpacing: false, // Prevent extra height when pinned
//     // markers: true // Show markers for debugging, can be removed later
// });

// Pin each child element when it reaches the center of the viewport
// children.forEach((child, index) => {
//   // console.log(child.clientHeight);
//   gsap.fromTo(child, {
    
//     // transform: 'translateY(0)',
//     // opacity: 1,
//     zIndex: 8,
//   }, {
//       scrollTrigger: {
//           trigger: child,
//           start: `top 20%`,
//           end: `bottom 20%`,
//           scrub: 0.2,
//           pin: true,
//           pinReparent: true,
//           markers: true
//       },
//       // transform: 'translateY(-50%)',
//       // opacity: 0,
//       zIndex: 10,
//   }
//   );

// });

const rows = document.querySelectorAll('.services__blink p');

    const startBlinking = (element) => {
        const blinkingDuration = Math.random() * 500 ; // Случайное время мигания от 1 до 3 секунд
        const blinkInterval = Math.random() * 4000 + 500; // Интервал между миганиями от 0.5 до 1.5 секунд

        element.classList.remove('blink'); // Начинаем с добавления класса
        setTimeout(() => {
            element.classList.add('blink'); // Скрываем элемент
        }, blinkingDuration);

        // Запускаем новый цикл мигания с интервалом
        setInterval(() => {
            element.classList.toggle('blink'); // Переключаем класс мигания
        }, blinkInterval);
    };

    // Запуск мигания для каждой строки
    rows.forEach(row => {
        startBlinking(row);
    });



})
let servicesFolio;


const services__features__list = new Swiper('.services__features__list', {
  observer: true,
  observeParents: true,
  slidesPerView: 'auto',
  speed: 650,
  // autoplay: {
  //   delay: 2000,
  //   disableOnInteraction: false,
  // },
  // freeMode: true,
  spaceBetween: 12, 
  mousewheel: {
      releaseOnEdges: true,
  },
  breakpoints: {
    576: {
      spaceBetween: 20,
    },
    1200: {
      spaceBetween: 30,
    },
    1800: {
      spaceBetween: 40
    }
  }
});

function initServicesSwiper() {
  if (window.innerWidth >= 992) {
    if (!servicesFolio) {
      servicesFolio = new Swiper('.services__folio__list:not(.portfolio__list):not(.case__rest__folio)', {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        speed: 650,
        slidesPerGroup: 1,
        // freeMode: true,
        spaceBetween: 12, 
        mousewheel: {
            releaseOnEdges: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 20,
          },
          992: {
            spaceBetween: 30,
            slidesPerView: 2
          },
          1800: {
            spaceBetween: 37,
            slidesPerView: 2
          }
        }
      });
    }
  } else {
    if (servicesFolio) {
      servicesFolio.destroy(true, true);
      servicesFolio = null; 
    }
  }
}
  


window.addEventListener('resize', initServicesSwiper);

document.addEventListener('DOMContentLoaded', function() {
  

  let case__rest__folio = new Swiper('.case__rest__folio', {
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    speed: 650,
    slidesPerGroup: 1,
    // freeMode: true,
    spaceBetween: 12, 
    mousewheel: {
        releaseOnEdges: true,
    },
    breakpoints: {
      576: {
        spaceBetween: 20,
      },
      992: {
        spaceBetween: 30,
        slidesPerGroup: 1,
      },
      1800: {
        spaceBetween: 37,
      }
    }
  });


  initServicesSwiper();

  const selectElements = document.querySelectorAll('.choicesSelect');

  if (selectElements.length) {
      selectElements.forEach(select => {
        const choicesInstance = new Choices(select, {
              removeItemButton: false,
              placeholder: true,
              searchEnabled: false,
              position: 'mixin',
              itemSelectText: '',
              shouldSort: false
          });
      });
  }

  const vacaHeads = document.querySelectorAll('.vacancies__list__item__head');

  vacaHeads.forEach(head => {
    head.addEventListener('click', function() {
        const body = this.nextElementSibling; // Select the corresponding body

        // Check if the body is currently collapsed
        if (body.style.maxHeight) {
            body.style.maxHeight = null; // Collapse
            body.classList.remove('expanded'); // Remove expanded class
            body.parentNode.classList.remove('active'); // Remove expanded class
        } else {
            body.style.maxHeight = body.scrollHeight + 'px'; // Expand
            body.classList.add('expanded'); // Remove expanded class
            body.parentNode.classList.add('active'); // Remove expanded class
        }
    });
  });

  const checkMap = document.getElementById("map");
  if (checkMap != null) {
    
    ymaps.ready(init);

    function init() {
        var myMap = new ymaps.Map("map", {
            center: [53.51608757095639,49.28216049999992], // Укажите координаты центра карты
            zoom: 17,
            controls: [
                // Добавим только необходимые элементы управления
                "zoomControl" // Например, оставим только контроль масштаба
                // Можно добавить и другие элементы, если нужно
            ]
        });
        myMap.behaviors.disable('scrollZoom');

        var myPlacemark = new ymaps.Placemark([53.51608757095639,49.28216049999992], {
            // balloonContent: 'Моя метка'
        }, {
            iconLayout: 'default#image',
            iconImageHref: '/images/map.svg', // Путь к вашей картинке
            iconImageSize: [84, 84], // Размеры картинки
            iconImageOffset: [-42, -84] // Смещение для правильной привязки
        });

        myMap.geoObjects.add(myPlacemark);
    }
  }

  revealElements();
});


const fixedheader = () => {
	let lastScroll = 0;
	const header = document.querySelector('.header');
	const defaultOffset = header.offsetHeight;
	const scrollPosition = () =>
		window.pageYOffset || document.documentElement.scrollTop;
	const containHide = () => header.classList.contains('hide');

	window.addEventListener('scroll', e => {
    
		if (
			scrollPosition() > lastScroll &&
			!containHide() &&
			scrollPosition() > defaultOffset
		) {

			header.classList.add('hide');
      document.querySelector('.header__mainMenu').classList.remove('_active');
		} else if (scrollPosition() < lastScroll && containHide()) {
			header.classList.remove('hide');
		}

		if (
			scrollPosition() > window.innerHeight/3
		) {
			header.classList.add('color');
		} else  {
			header.classList.remove('color');
		}


		lastScroll = scrollPosition();
	});
}


// Function to reveal elements on scroll
const revealElements = () => {
  gsap.utils.toArray('.contacts__map').forEach((elem) => {
      ScrollTrigger.create({
          trigger: elem,
          start: 'top 80%', 
          toggleClass: 'visible', 
          toggleActions: 'play none none none',
          once: true, 
      });
  });
  // const isMainPage = document.querySelector('');
  // if (isMainPage == null) {
      gsap.utils.toArray('.iworks__head,.vacancies__list__item,.contacts__wrap,.contacts h1,.iworks__big,.iworks__mid,.iworks .title,.iworks__rest__right,.iworks__rest__bottom,.iworks__title,.feedback__form,.footer__logo,.blog__list__item,.services__grad,.services__sideText,.services__folio__head .h1,.services__folio__head h2,a.back,.case__leadNav,.article__body p,.article__body h2,.article__imgWide,.article__imgBig,.article__body ul,.article__body ol,.article__img,.article__opinion .h1,.article__opinion__img,.article__opinion__in,.services__calendars__mix,.services__calendars__right,.services__calendars__left,.services__calendars__earth').forEach((elem) => {
          ScrollTrigger.create({
              trigger: elem,
              start: 'top 94%', 
              toggleClass: 'visible', 
              toggleActions: 'play none none none',
              once: true, 
          });
      });

      const layersParalax = [
          { element: '.services__calendars__mix__wrap', speed: 0.1 },
          { element: '.services__calendars__right__wrap', speed: 0.16 },
          
          { element: '.services__calendars__left__wrap', speed: 0.3 }
      ];
      
      layersParalax.forEach(layer => {
        const speed = layer.speed; 
          gsap.to(layer.element, {
              // y: '-100%',  // смещение по Y
              scrollTrigger: {
                  trigger: '.services__calendars',
                  start: 'top bottom',
                  end: 'bottom top',
                  scrub: true,
                  onUpdate: function(scrollTrigger) {
                    const progress = scrollTrigger.progress; // Получаем прогресс
                    gsap.set(layer.element, { y: -progress * 100 * speed + 'vh' });
                }
              },
              ease: 'none'
          });
      });


      const ilayersParalax = [
        // { element: '.iworks__mid__wrap', speed: 0.2 },
        { element: '.iworks__rest__right__wrap', speed: 0.2 },
        { element: '.iworks__title__wrap', speed: 0.15 },
        { element: '.iworks__rest__bottom__wrap', speed: 0.1 }
      ];
      
      ilayersParalax.forEach(layer => {
        const speed = layer.speed; 
          gsap.to(layer.element, {
              // y: '-100%',  // смещение по Y
              scrollTrigger: {
                  trigger: '.iworks__rest',
                  start: 'top center',
                  end: 'bottom top',
                  scrub: true,
                  onUpdate: function(scrollTrigger) {
                    const progress = scrollTrigger.progress; // Получаем прогресс
                    gsap.set(layer.element, { y: -progress * 100 * speed + 'vh' });
                }
              },
              ease: 'none'
          });
      });


      setTimeout(() => {
      gsap.utils.toArray('.services__folio__list .swiper-slide, .portfolio__nav').forEach((elem) => {
          ScrollTrigger.create({
              trigger: elem,
              start: 'top 110%', 
              toggleClass: 'visible', 
              toggleActions: 'play none none none',
              once: true, 
          });
      });
      }, window.innerWidth > 2100 ? 1900 : 0);
  // }

  if (windowWidth > 992) { 
    setTimeout(() => {
      gsap.utils.toArray('.clients__list__item').forEach((elem) => {
        ScrollTrigger.create({
            trigger: elem,
            start: 'top 100%', 
            toggleClass: 'visible', 
            toggleActions: 'play none none none',
            once: true, 
        });
    });
    }, 666);
  }
};




function optimizationOfVideos() {
  const videos = document.querySelectorAll("video[autoplay]");

  let observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              if (entry.target.paused) {
                  entry.target.play();
                  entry.target.dataset.pauseVideo = false;
              }
          } else {
              entry.target.pause();
              entry.target.dataset.pauseVideo = true;
          }
      });
  });

}
